import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrSidepanelComponent } from './pr-sidepanel.component';
import { PrSidepanelService } from './pr-sidepanel.service';

@NgModule({
  declarations: [PrSidepanelComponent],
  imports: [CommonModule],
  providers: [PrSidepanelService],
  exports: [PrSidepanelComponent],
})
export class PrSidepanelModule {}
